import { setupWebSocket } from '../actions/websockets'
import getConnectedHistory from './get-connected-history'
import setupPersist from './setup-persist'
import createReduxStore from './create-redux-store'
import connectWsToDispatch from './connect-ws-to-dispatch'
import config from 'config'

// TODO: Figure out why changing to default export breaks everything
export async function initializeStore(reducers, usePersist = false, useWs = false) {
  const websocket = useWs ? await setupWebSocket({ uri: config.WEB_SOCKET_URI }) : null

  const store = createReduxStore(reducers, usePersist, websocket)

  if (websocket) {
    connectWsToDispatch(websocket, store.dispatch, store.getState)
  }

  const history = getConnectedHistory(store)

  if (usePersist) {
    setupPersist(store)
  }

  return { store, history }
}
